import {
  Introduction,
  Job,
  JobCompanyInfo,
} from '@kanda-libs/ks-frontend-services';

export const formatTradingName = (
  job?: Job,
  jobCompanyInfo?: JobCompanyInfo,
  introduction?: Introduction,
) => {
  if (job?.introduced_to) {
    return (
      introduction?.trader_details?.limited_company_info?.company_name ||
      introduction?.trader_details?.sole_trader_info?.trading_name ||
      introduction?.trader?.trading_name ||
      'your tradesperson'
    );
  }
  const companyName = jobCompanyInfo?.company_name;
  const tradingName = jobCompanyInfo?.contact_info?.trading_name;
  return tradingName || companyName || 'your tradesperson';
};
